// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section1_Section__2ZbOF","HeadText":"Section1_HeadText__15hqP","tileBox":"Section1_tileBox__3dbWo","tile":"Section1_tile__1oCdA","HeadLine":"Section1_HeadLine__1aMse"};